/* unplugin-vue-components disabled */import script from "./OrderTableBlock.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrderTableBlock.vue?vue&type=script&setup=true&lang=ts"

import "./OrderTableBlock.vue?vue&type=style&index=0&id=9bbd0cde&scoped=true&lang=less"
import "./OrderTableBlock.vue?vue&type=style&index=1&id=9bbd0cde&lang=less"

import exportComponent from "/data/jenkins/workspace/infra_PayAdminWeb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9bbd0cde"]])

export default __exports__